import { apiFetch } from "./apiClient";

// Taste signals (Feature 73) — three-state ratings (👎 -1 / 👍 1 / ❤️ 2) and
// explicit watched overrides ('watched' | 'unwatched'), invite-scoped like
// My List. Thin wrappers over the /api/ratings + /api/watched routes plus the
// Gemini-tier GET /api/suggest/for-you probe. The Pinia taste store
// (stores/taste.js) owns caching + optimistic state; use it instead of
// calling these directly from components.

export function listRatings() {
  return apiFetch("/api/ratings").then((r) => r.ratings || []);
}

export function setRating(mediaType, tmdbId, rating, { title, year } = {}) {
  const json = { rating };
  if (title != null) json.title = title;
  if (year != null) json.year = year;
  return apiFetch(
    `/api/ratings/${encodeURIComponent(mediaType)}/${encodeURIComponent(tmdbId)}`,
    { method: "PUT", json },
  );
}

export function clearRating(mediaType, tmdbId) {
  return apiFetch(
    `/api/ratings/${encodeURIComponent(mediaType)}/${encodeURIComponent(tmdbId)}`,
    { method: "DELETE" },
  );
}

export function listWatched() {
  return apiFetch("/api/watched").then((r) => r.watched || []);
}

export function setWatched(mediaType, tmdbId, state, { title, year } = {}) {
  const json = { state };
  if (title != null) json.title = title;
  if (year != null) json.year = year;
  return apiFetch(
    `/api/watched/${encodeURIComponent(mediaType)}/${encodeURIComponent(tmdbId)}`,
    { method: "PUT", json },
  );
}

export function clearWatched(mediaType, tmdbId) {
  return apiFetch(
    `/api/watched/${encodeURIComponent(mediaType)}/${encodeURIComponent(tmdbId)}`,
    { method: "DELETE" },
  );
}

// "AI picks for you" — permission-gated (suggest-movies) + key-gated on the
// server; returns { items: [] } when unconfigured or <3 positive ratings,
// 403 when the invite lacks the permission (callers hide the shelf).
export function getForYou() {
  return apiFetch("/api/suggest/for-you").then((r) =>
    Array.isArray(r?.items) ? r.items : [],
  );
}
